module.exports = __webpack_public_path__ + "static/media/emilysTeaParty2007.162c1a37.jpg";